import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SchoolMasterCreateRequestDTO, SchoolMasterDTO, SchoolMasterUpdateRequestDTO,
  SchoolMasterList, SchoolMasterDeleteRequestDTO, SchoolMasterReadByIdRequestDTO,
  SchoolMasterFetchDetailsByParentIdRequestDTO, SchoolMasterDetailsResponseDTO,
  SchoolMasterOnboardingCompleteRequestDTO, SchoolSummary,
  StaffAttendenceGraphRequestDTO, AttendanceStaffList,
  WhatsAppConfigCreateRequestDTO, WhatsAppConfigDTO, WhatsAppConfigList, WhatsAppConfigReadByModuleRequestDTO
} from './school-master.interface';
import {
  SchoolMaster_Create, SchoolMaster_Update, SchoolMaster_ReadAll,
  SchoolMaster_Delete, SchoolMaster_ReadById, SchoolMaster_ReadAllPaginated,
  SchoolMaster_ReadByParentId, SchoolMaster_OnboardingReadAllPaginated,
  SchoolMaster_OnboardingComplete, SchoolMaster_GetSummary, SchoolMaster_ExternalReadById,
  WhatsAppConfig_Create, WhatsAppConfig_QRCode, WhatsAppConfig_ReadAll, WhatsAppConfig_ReadByModule
} from 'src/app/GlobalVariable';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root'
})
export class SchoolMasterService {
  constructor() { }
  http = inject(HttpClient)

  SchoolMaster_Create(data: SchoolMasterCreateRequestDTO): Observable<SchoolMasterDTO> {
    return this.http.post<SchoolMasterDTO>(SchoolMaster_Create, data)
  }
  SchoolMaster_Update(data: SchoolMasterUpdateRequestDTO): Observable<SchoolMasterDTO> {
    return this.http.post<SchoolMasterDTO>(SchoolMaster_Update, data)
  }
  SchoolMaster_ReadAll(): Observable<SchoolMasterList> {
    return this.http.get<SchoolMasterList>(SchoolMaster_ReadAll)
  }
  SchoolMaster_GetSummary(): Observable<SchoolSummary> {
    return this.http.get<SchoolSummary>(SchoolMaster_GetSummary)
  }
  SchoolMaster_ReadAllPaginated(data: PaginatedDTO): Observable<SchoolMasterList> {
    return this.http.post<SchoolMasterList>(SchoolMaster_ReadAllPaginated, data)
  }
  SchoolMaster_OnboardingReadAllPaginated(data: PaginatedDTO): Observable<SchoolMasterList> {
    return this.http.post<SchoolMasterList>(SchoolMaster_OnboardingReadAllPaginated, data);
  }
  SchoolMaster_OnboardingComplete(data: SchoolMasterOnboardingCompleteRequestDTO): Observable<void> {
    return this.http.post<void>(SchoolMaster_OnboardingComplete, data);
  }
  SchoolMaster_Delete(data: SchoolMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SchoolMaster_Delete, data)
  }
  SchoolMaster_ReadByParentId(data: SchoolMasterFetchDetailsByParentIdRequestDTO): Observable<SchoolMasterDetailsResponseDTO> {
    return this.http.post<SchoolMasterDetailsResponseDTO>(SchoolMaster_ReadByParentId, data)
  }
  SchoolMaster_ReadById(data: SchoolMasterReadByIdRequestDTO): Observable<SchoolMasterDTO> {
    return this.http.post<SchoolMasterDTO>(SchoolMaster_ReadById, data)
  }
  SchoolMaster_ExternalReadById(
    data: SchoolMasterReadByIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<SchoolMasterDTO> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set('X-Api-Key', xApiKey)
        .set('X-Api-Timestamp', xApiTimestamp || '')
        .set('X-Api-Nonce', xApiNonce || '')
        .set('X-Api-Signature', xApiSignature);
    }
    return this.http.post<SchoolMasterDTO>(SchoolMaster_ExternalReadById, data, { headers });
  }
  SchoolMaster_StaffAttendanceOverview(data: StaffAttendenceGraphRequestDTO): Observable<AttendanceStaffList> {
    return this.http.post<AttendanceStaffList>(SchoolMaster_ExternalReadById, data)
  }
  WhatsAppConfig_Create(data: WhatsAppConfigCreateRequestDTO): Observable<WhatsAppConfigDTO> {
    return this.http.post<WhatsAppConfigDTO>(WhatsAppConfig_Create, data)
  }
  WhatsAppConfig_ReadAll(): Observable<WhatsAppConfigList> {
    return this.http.get<WhatsAppConfigList>(WhatsAppConfig_ReadAll);
  }
  WhatsAppConfig_ReadByModule(data: WhatsAppConfigReadByModuleRequestDTO): Observable<WhatsAppConfigList | WhatsAppConfigDTO[]> {
    return this.http.post<WhatsAppConfigList | WhatsAppConfigDTO[]>(WhatsAppConfig_ReadByModule, data);
  }
  WhatsAppConfig_QRCode(sessionName: string): Observable<Blob> {
    return this.http.get(WhatsAppConfig_QRCode + '/' + encodeURIComponent(sessionName), {
      responseType: 'blob'
    });
  }
}
